// extracted by mini-css-extract-plugin
export default {"main":"Loader_main__jH8Cf","wrapper":"Loader_wrapper__JYeTW","text":"Loader_text__EDGdc"};